import { Navigate, Outlet } from 'react-router-dom'
import { getTokenMember } from '../utils/app.utils';


const token = getTokenMember();

interface authenticationProps {
    isAccept: boolean;
}
const MemberRoute = () => {
    let auth: authenticationProps = { isAccept: !!token };

    return (
        auth.isAccept ? <Outlet /> : <Navigate to="/login-member" />
    )
}

export default MemberRoute